<template>
  <a-card class="m-t-10" :bordered="false">
    <p class="fz-16 s_font_b p-b-20">
      <a-button class="m-r-10" size='small' @click="()=>{$router.go(-1)}">
        <LeftOutlined />返回
      </a-button>
      出库操作
    </p>
    <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" >
      <a-form-item label="入库单号" name='warehousing_sn'>
        <span>{{form.warehousing_sn}}</span>
      </a-form-item>
      <a-form-item label="出库单号" name='out_warehousing_sn'>
        <span>{{form.out_warehousing_sn}}</span>
      </a-form-item>
      <a-form-item label="出库类型" name='out_warehousing_type'>
        <a-radio-group v-model:value="form.out_warehousing_type" @change='storeChange' :disabled="isDisabled">
          <a-radio :value="1">出库给直属经销商</a-radio>
          <a-radio :value="2">出库给直属门店</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item :label="form.out_warehousing_type == 1 ? '经销商名称':'门店名称'" name='out_warehousing_to_id'>
        <a-input :placeholder="form.out_warehousing_type == 1 ? '请选择经销商':'请选择门店'" style="width: 380px;margin-right: 10px;"
          readonly v-model:value="form.out_warehousing_to_name"></a-input>
        <a-button type="primary" @click="openStoreSelect" :disabled="isDisabled">选择{{form.out_warehousing_type == 1 ? '经销商':'门店'}}</a-button>
      </a-form-item>
      <a-form-item label="出库仓库" name='warehouse_id' >
        <a-select v-model:value="form.warehouse_id" style='width: 380px' placeholder='请选择仓库' @change='selectChange' :disabled="isDisabled">
          <a-select-option v-for='item in warehouseList' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="仓位" name='position_id'>
        <a-select v-model:value="form.position_id" style='width: 380px;' placeholder='请选择库位' :disabled="!form.warehouse_id || isDisabled" >
          <a-select-option v-for='item in warehouseChild' :key='item.id' :value="item.id">{{item.name}}
          </a-select-option>
        </a-select>
        <a-button class='m-l-10' @click='form.position_id = null' :disabled="!form.warehouse_id || isDisabled">清空</a-button>
      </a-form-item>
      <a-form-item label="物流公司">
        <a-select v-model:value="form.logistics_name" style='width: 380px' placeholder='请选物流公司'>
          <a-select-option v-for='item in logisticsList' :key='item.name' :value="item.name">{{item.name}}
          </a-select-option>
        </a-select>
        <a-button class='m-l-10' @click='form.logistics_name=null'>清空</a-button>
      </a-form-item>
      <a-form-item label="物流单号">
        <a-input style="width: 480px" v-model:value="form.logistics_code" placeholder='请输入物流单号'></a-input>
      </a-form-item>
      <a-form-item label="使用生产批次入库" name="" >
        <a-radio-group v-model:value="form.use_product_batch" @change='radioChange' :disabled="isDisabled">
          <a-radio :value="0">否</a-radio>
          <a-radio :value="1">是</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label='生产批次' v-if='form.use_product_batch == 1' name='product_batch_id'>
        <a-input style="width: 480px;margin-right: 10px;" readonly v-model:value="form.product_batch_name" placeholder='请选择生产批次'></a-input>
        <a-button type="primary" @click="showBatch = true" :disabled="isDisabled">选择</a-button>
      </a-form-item>
      <a-form-item label="商品名称" name='product_name'>
        <a-input-group compact style="width: 480px;margin-right: 10px;">
          <a-input style="width: 120px" v-model:value="form.product_sku_sn_name" placeholder='商品编号' readonly />
          <a-input style="width: 360px;" readonly v-model:value="form.product_name" placeholder='请选择商品'/>
        </a-input-group>
        <a-button type="primary" @click="showGood = true" :disabled="form.use_product_batch == 1 || isDisabled" >选择</a-button>
      </a-form-item>
      <a-form-item label="扫码类型" name='scan_type'>
        <a-radio-group v-model:value="form.scan_type" @change='form.code_sn = ""'>
          <a-radio :value="1">正常扫码</a-radio>
          <a-radio :value="2">回退扫码</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="扫描二维码" name='code_sn' help='录入的二维码不是最高级别，系统将自动进行拆箱操作，把关联的上级二维码无效化'>
        <a-input style="width: 480px;margin-right: 10px;" v-model:value="form.code_sn" @pressEnter='scanCode' placeholder="请输入二维码"></a-input>
        <a-button class='m-r-10' type="primary" @click='scanCode' :loading='submitLoading'>添加</a-button>
        <a-tooltip placement='right'>
          <template #title>
            <p>1、点击“添加”后数据直接保存。如果使用扫描枪设备，不需要点击“添加”按钮，设备扫描完成会自动保存。</p>
            <p>2、使用扫描枪扫描时注意先将“光标”放到输入框中。（鼠标点一下输入框）</p>
            <p>3、程序自带提示音，会根据录入结果提示对应的声音，方便盲扫，请确保电脑带有声音播放功能。</p>
          </template>
          <InfoCircleOutlined class="fz-18" />
        </a-tooltip>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 3}">
        <a-checkbox v-model:checked="form.is_gift">扫码商品标记为赠品</a-checkbox>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 3}" v-if='showResult'>
        <div class="p-24 s_bf7">
          <p class="s_lin_h30 s_font_b">本次出库库数量计数</p>
          <p class="s_lin_h30">扫码数量：{{scanCodeNum}}</p>
          <p class="s_lin_h30">成功数量：{{successNum}}</p>
          <p class="s_lin_h30">成功商品数量：{{successGoodsNum}}</p>
          <a-button type='primary' @click='showCode = true'>查看出库二维码</a-button>
        </div>
        <a-card class='m-t-10'>
          <p class="s_lin_h30">扫码结果：</p>
          <p class="s_lin_h30">
            <span v-if='form.scan_type == 1'>{{resultCode == 0 ? '出库成功！':'出库失败！'}}</span>
            <span v-else>{{resultCode == 0 ? '回退成功！':'回退失败！'}}</span>
          </p>
          <p class="s_lin_h30" v-if='resultCode != 0'>失败原因：</p>
          <p class="s_lin_h30" v-if='resultCode != 0'>{{resultMsg}}</p>
        </a-card>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 3}">
        <a-button class="width-100 m-r-20" block @click="()=>{$router.go(-1)}">退出</a-button>
        <!-- <a-button class="width-100 m-r-20" block type="primary" @click="onSubmit('all')">确定出库</a-button> -->
      </a-form-item>
    </a-form>
  </a-card>
  <a-modal :keyboard="false" title="选择门店" v-model:visible="showStore" centered :width='1300' :footer="null"
    destroyOnClose>
    <!-- <selectStore :checkout='false' v-on:select="storeSelect" :selectList='[{id:form.out_warehousing_to_id}]' :hiddenHead='true'></selectStore> -->
    <selectStore :checkout='false' v-on:select="storeSelect" :selectList='[{id:form.out_warehousing_to_id}]' :hiddenHead='true'></selectStore>
  </a-modal>
  <a-modal :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1300' :footer="null"
    destroyOnClose>
    <!-- <selectDealer :checkout='false' v-on:select="storeSelect" :selectList='[{id:form.out_warehousing_to_id}]'></selectDealer> -->
    <selectDealer :checkout='false' v-on:select="storeSelect" :selectList='[{id:form.out_warehousing_to_id}]'></selectDealer>
  </a-modal>
  <a-modal  :keyboard="false" title="选择商品" v-model:visible="showGood" centered :width='1300' :footer="null" destroyOnClose>
    <selectGood v-on:select="goodSelect" :selectList='[{key:selectListId}]' :checkout="false" :skuType='true'></selectGood>
  </a-modal>
  <a-modal :keyboard="false" :width='1300' centered v-model:visible="showCode" destroyOnClose :footer="null">
    <template #title>
      <span class="fz-16">出库二维码</span>
      <span class="fz-14 s_c999">（进行拆箱发货的小标，删除后关联的中标和大标依然无效）</span>
    </template>  
    <warehouseOutCode v-on:select='codeConfirm' :id='form.out_warehousing_sn' :productId='form.product_id' :productSkuSn='form.product_sku_sn' :showAction='false'></warehouseOutCode>
  </a-modal>
  <a-modal  :keyboard="false" title="选择生产批次" v-model:visible="showBatch" centered :width='1300' :footer="null" destroyOnClose>
    <selectGoodBatch v-on:select="batchSelect" :selectList='[{id:form.product_batch_id}]' :checkout="false"></selectGoodBatch>
  </a-modal>
  <a-modal :keyboard="false" centered v-model:visible="showError" :closable='false'>
    <p class="fz-18 s_font_b text-ac m-b-20">二维码有误，无法发货</p>
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p>
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p>
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p>
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p> 
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p>
    <p class="text-ac s_lin_h30">二维码编号”00230477“商品无法进行出库操作</p>
  </a-modal>
</template>

<script>
  import { ref, onMounted, onUnmounted, inject, reactive, toRefs, h } from "vue";
  import { LeftOutlined,InfoCircleOutlined } from "@ant-design/icons-vue";
  import { message } from "ant-design-vue";
  import { iscode } from "@/utils/app";
  import { generateNumber } from "@/utils/utils";
  import { useUsbRead } from "@/hooks/useUsbRead";
  import store from "@/store";
  import { getWarehouseList,getWarehousingSn,getOutWarehousingSn,setOutWarehousing,setOutWarehousingFast,setOutWarehousingGift,closeRefundOrder } from '@/api/antiFleeing';
  import { getExpressList } from "@/api/order";
  import warehouseOutCode from './components/warehouseOutCode.vue' 
  import selectStore from './components/selectStore.vue' 
  import selectDealer from './components/selectDealer.vue' 
  let defForm = {
    out_warehousing_type:1,
    out_warehousing_to_id:'',
    logistics_name: null,
    logistics_code: '',
    warehouse_id:null,
    position_id:null,
    warehousing_sn:'',
    use_product_batch:0,
    product_batch_id:'',
    product_id:'',
    product_sku_sn:'',
    scan_type:1,
    code_sn:'',
    out_warehousing_sn:'',
    is_gift:0
  };
  export default {
    components: { LeftOutlined,InfoCircleOutlined,warehouseOutCode,selectStore,selectDealer },
    setup() {
      const ruleForm = ref();
      const form = ref({ ...defForm });
      const validatePass = async (rule, value) => {
            if(state.rulesStatus){
               if(value==''){
                return Promise.reject('二维码不能为空');
                }
            }else{
                return Promise.resolve();
          }
      }
      const state = reactive({
        submitLoading:false,
        info: store.state.user.info,
        labelCol: {span: 3},
        wrapperCol: {span: 13},
        showStore: false, //是否显示选择门店
        showDealer: false, //是否显示选择经销商
        showGood:false, //是否显示选择商品
        showCode:false, //是否显示出库二维码
        showError:false, // 是否显示错误二维码列表
        showBatch:false, // 是否显示选择批次
        isDisabled:false,// 扫码成功禁用一些选项
        goodList:[], // 产品列表
        selectListId:'',
        warehouseList:[], // 仓库列表
        warehouseChild:[], // 库位列表
        logisticsList:[], // 物流公司列表
        scanCodeNum:0, //扫码数量
        successNum:0, // 成功数量
        successGoodsNum:0, //成功商品数量
        showResult:false, // 是否显示扫码结果
        resultCode:'', //扫码结果code
        resultMsg:'', // 扫码结果提示语
        rulesStatus:true, // 出库不校验二维码，添加时校验--胖子说的
        rules: {
          out_warehousing_type: [
            { required: true, message: '请选择出库类型',type:'number'}
          ],
          out_warehousing_to_id: [
            { required: true, message: form.value.out_warehousing_type == 1? '请选择经销商':'请选择门店',type:'number'}
          ],
          warehouse_id: [
            { required: true, message: '请选择发货仓库',type:'number'}
          ],
          product_name: [
            { required: true, message: '请选择商品'}
          ],
          product_batch_id: [
            { required: true, message: '请选择生产批次'}
          ],
          scan_type:[
            { required: true,  message: '请选择扫码类型',type:'number'}
          ],
          code_sn:[
            // { required: true,  message: '二维码不能为空'}
            {
              validator: validatePass
            }
          ]
        },
        columns: [
          {
            title: "商品编码",
            dataIndex: "product_sn",
            key: "product_sn"
          },
          {
            title: "商品信息",
            dataIndex: "gift_name",
            key: "gift_name",
            slots: { customRender: "gift_name" },
          },
          {
            title: "规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "出库数量",
            dataIndex: "num",
            key: "num",
            slots: { customRender: "num" },
          },
          {
            title: "操作",
            key: "action",
            width:240,
            slots: { customRender: "action" }
          }
        ]
      });
      const $route = inject("$route");
      const $Modal = inject("$Modal");
      const $router = inject("$router");
      // 获取仓库
      const getWarehouse = async () => {
        let res = await getWarehouseList().then(res => res.data);
        if (iscode(res)) {
          state.warehouseList = res.data;
            // 默认选择默认仓库
          form.value.warehouse_id=res.data[0].id
        } else {
          message.error(res.msg);
        }
      }
      //选择仓库
      const selectChange = () =>{
        form.value.position_id = null
        var item = state.warehouseList.find(v => v.id == form.value.warehouse_id)
        state.warehouseChild = item.child || []
      }
      // 生成出库单号
      const outWarehousingSnGet = async () => {
        let res = await getOutWarehousingSn().then(res => res.data);
        if (iscode(res)) {
          form.value.out_warehousing_sn = res.data.order_no;
        } else {
          message.error(res.msg);
        }
      }
      // 生成入库单号
      const warehousingSnGet = async (e) => {
        let res = await getWarehousingSn().then(res => res.data);
        if (iscode(res)) {
          form.value.warehousing_sn = res.data.sn;
        } else {
          message.error(res.msg);
        }
      }
      // 获取物流公司
      const getLogistics = async () => {
        let res = await getExpressList({keyword: '',page: 1,limit: 100,}).then(res => res.data);
        if (iscode(res)) {
          state.logisticsList = res.data.data;
        } else {
          message.error(res.msg);
        }
      }
      const storeChange = () => {
        form.value.out_warehousing_to_name = "";
        form.value.out_warehousing_to_id = "";
      }
      //打开选择门店/经销商
      const openStoreSelect = () =>{
        if(form.value.out_warehousing_type == 1){
          state.showDealer = true
        }else{
          state.showStore = true
        }
      }
      //选择门店/经销商
      const storeSelect = (e) => {
        // form.value.out_warehousing_to_id = e.id || e.dealer_id;
        // form.value.out_warehousing_to_name = e.store_name || e.dealer_name;
        form.value.out_warehousing_to_id = e.id || '';
        form.value.out_warehousing_to_name = e.name || '';
        state.showStore = false;
        state.showDealer = false;
      }
      
      // 是否使用生产批次切换
      const radioChange = () => {
        form.value.product_id = ''
        form.value.product_name = ''
        form.value.product_sku_sn = ''
        form.value.product_sku_sn_name = ''
        form.value.product_batch_id = ''
        form.value.product_batch_name = ''
      }
      //选择商品
      const goodSelect = (e) => {
        if(e.spec_type == 1){
          state.selectListId = e.id+'_'+e.product_sn
        }else{
          state.selectListId = e.id+'_'+e.product_sku_sn
        }
        form.value.scan_type = 1;
        form.value.code_sn = '';
        form.value.use_product_batch = 0;
        form.value.product_id = e.id
        form.value.product_name = (e.product_sku_name?e.product_sku_name:'单规格')+' - '+e.product_name
        form.value.product_sku_sn = e.product_sku_sn || 0
        form.value.product_sku_sn_name = e.product_sku_sn || e.product_sn
        state.showGood = false;
      }
      //选择批次
      const batchSelect = (e) =>{
        form.value.product_id = e.product_id
        form.value.product_name = (e.product_sku_name?e.product_sku_name:'单规格')+' - '+e.product_name
        form.value.product_sku_sn = e.product_sku_sn || 0
        form.value.product_sku_sn_name = e.product_sku_sn || e.product_sn
        form.value.product_batch_id = e.id
        form.value.product_batch_name = e.batch_name
        state.showBatch = false
      }
      //取消
      const onCancel = () =>{
        $Modal.confirm({
          centered: true,
          title: '退出出库？',
          content: '退出后扫码出库商品将取消出库，进行拆箱发货的中标和大标依然无效',
          async onOk() {
            if(state.isDisabled){ //扫码成功后才调用
                 let res = await closeRefundOrder(form.value.out_warehousing_sn).then(res=>res.data).catch(error => error);
               if(iscode(res)){
                 message.success(res.msg);
                 $router.go(-1)
               }else{
                 message.error(res.msg);
               }
            }else{
              $router.go(-1)
            }
          }
        })
      }
      //出货二维码操作
      const codeConfirm = async(e) =>{
        var setting = [e.code_batch_sn+'_'+e.code_sn+'_'+e.code_type+'_'+e.is_gift];
        const hide = message.loading("正在加载中...", 0);
        let res = await setOutWarehousingGift( {id:form.value.out_warehousing_sn,setting:setting} ).then((res) => res.data).catch(error => error);
        if (iscode(res)) {
          message.success(res.msg);
        } else {
          message.error(res.msg);
        }
        setTimeout(hide);
      }
      //扫码
      const scanCode = () => {
        state.rulesStatus = true;
        ruleForm.value.validate().then(async() => {
          const hide = message.loading("正在加载中...", 0);
          state.submitLoading = true;
          let res = await setOutWarehousingFast({ ...form.value,is_gift:form.value.is_gift ? 1:0}).then((res) => res.data).catch(error => error);
          if (iscode(res)) {
            message.success(res.msg);
            state.scanCodeNum = state.scanCodeNum+1
            state.successNum = state.successNum+1
            // if(form.value.scan_type==1){ //扫码
            //   state.successGoodsNum = state.successGoodsNum+res.data.num;
            // }else{ //回退
            // }
             state.successGoodsNum = res.data.num;
            state.isDisabled = true
          } else {
            message.error(res.msg);
          }
          state.resultCode = res.code
          state.resultMsg = res.msg
          state.showResult = true
          form.value.code_sn = ''
          state.submitLoading = false;
          setTimeout(hide);
        }).catch(error => {
          message.error('请完善表单！');
        });
      };
      //提交
      const onSubmit = (text) => {
           state.rulesStatus = false;
           ruleForm.value.validate().then(async() => {
              $Modal.confirm({
                    centered: true,
                    title: '确定出库？',
                    async onOk() {
                      const hide = message.loading("正在加载中...", 0);
                      let res = await setOutWarehousing({part:0,id:form.value.out_warehousing_sn,logistics_name:form.value.logistics_name,logistics_code:form.value.logistics_code}).then((res) => res.data).catch(error => error);
                      if (iscode(res)) {
                        message.success(res.msg);
                        setTimeout(() => {
                          $router.go(-1);
                        }, 2000);
                      } else {
                        message.error(res.msg);
                      }
                      setTimeout(hide);
                    }
                  })
           }).catch(error => {
            message.error('请完善表单！');
           });
 

        // if(!state.showResult){
        //   message.error('没有扫描过任何二维码！');
        //   return
        // }
      
      };
      // 监听USB读取
      const { openUSBbRead, closeUSBbRead } = useUsbRead();
      onMounted(() => {
        getLogistics();
        getWarehouse();
        outWarehousingSnGet();
        warehousingSnGet();
        // 开始监听USB读卡器
        openUSBbRead((data) => {
          if (data && data != form.value.code_sn) {
            form.value.code_sn = data;
          }
        });
      });
      onUnmounted(() => {
        closeUSBbRead();
      });
      return {
        form,
        ruleForm,
        ...toRefs(state),
        onSubmit,
        onCancel,
        storeSelect,
        goodSelect,
        openStoreSelect,
        radioChange,
        batchSelect,
        scanCode,
        codeConfirm,
        selectChange,
        storeChange
      };
    },
  };
</script>